<template>
  <img
    v-if="img"
    :src="src"
    alt=""
  >
  <q-img
    v-else
    :src="src"
  >
    <slot />
  </q-img>
</template>

<script>
/**
 * Componsant générique capable de gérer les photos dans l'appli
 */
export default {
  name: 'LwfPhoto',
  props: {
    picture: {
      type: Object,
      default: _.stubObject
    },
    emptySrc: {
      type: String,
      default: undefined
    },
    img: Boolean
  },
  computed: {
    src () {
      const { base64, url, path, name, extension } = this.picture
      if (base64) {
        return base64
      }
      if (url) {
        return url
      }
      if (path && name && extension) {
        return `${path}/${name}.${extension}`
      }
      return this.emptySrc
    }
  }
}
</script>

<style scoped>

</style>
